import { __read, __spreadArray } from "tslib";
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Silent"] = 0] = "Silent";
    LogLevel[LogLevel["Error"] = 1] = "Error";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Breadcrumb"] = 3] = "Breadcrumb";
    LogLevel[LogLevel["Info"] = 4] = "Info";
    LogLevel[LogLevel["Verbose"] = 5] = "Verbose";
})(LogLevel || (LogLevel = {}));
var Logger = /** @class */ (function () {
    function Logger(rawContext, logHandlers, opts) {
        if (rawContext === void 0) { rawContext = ''; }
        if (logHandlers === void 0) { logHandlers = new Array(); }
        this.rawContext = rawContext;
        this.logHandlers = logHandlers;
        this.opts = opts;
        this.verbose = this.runHandlers(LogLevel.Verbose, 'verbose');
        this.info = this.runHandlers(LogLevel.Info, 'info');
        this.breadcrumb = this.runHandlers(LogLevel.Breadcrumb, 'breadcrumb');
        this.warn = this.runHandlers(LogLevel.Warn, 'warn');
        this.error = this.runHandlers(LogLevel.Error, 'error');
    }
    Logger.prototype.withContext = function (additionalContext) {
        var context = this.rawContext ? "".concat(this.rawContext, ":").concat(additionalContext) : additionalContext;
        return new Logger("".concat(context), this.logHandlers, this.opts);
    };
    Logger.prototype.addLogger = function (logHandler) {
        this.logHandlers.push(logHandler);
    };
    Logger.prototype.getLogLevel = function () {
        if (this.logHandlers.length === 0) {
            return null;
        }
        return this.logHandlers.reduce(function (current, currentMax) { return (current.logLevel > currentMax.logLevel ? current : currentMax); }).logLevel;
    };
    Logger.prototype.getLogHandlers = function () {
        return this.logHandlers;
    };
    Logger.prototype.runHandlers = function (logLevel, func) {
        var _this = this;
        return function () {
            var messages = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                messages[_i] = arguments[_i];
            }
            try {
                _this.logHandlers.forEach(
                // @ts-ignore
                function (handler) {
                    var _a;
                    var args = ((_a = _this.opts) === null || _a === void 0 ? void 0 : _a.disablePrefix) ? __spreadArray([], __read(messages), false) : __spreadArray([_this.getPrefix(logLevel)], __read(messages), false);
                    var handlerFunction = handler[func];
                    if (handler.logLevel >= logLevel && handlerFunction) {
                        handlerFunction.apply(void 0, __spreadArray([], __read(args), false));
                    }
                });
            }
            catch (e) {
                console.error("Error when logging ".concat(func, " ").concat(e));
            }
        };
    };
    Logger.prototype.getPrefix = function (logLevel) {
        var timestamp = "[".concat(new Date().toISOString(), "]");
        var context = "[".concat(this.rawContext, "]");
        var logLevelKey = "[".concat(LogLevel[logLevel].toUpperCase(), "]");
        return [timestamp, context, logLevelKey].join(' ');
    };
    return Logger;
}());
export { Logger };
export function createConsoleLogHandler(logLevel) {
    return {
        logLevel: logLevel,
        verbose: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return console.debug.apply(console, __spreadArray([], __read(args), false));
        },
        breadcrumb: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return console.log.apply(console, __spreadArray([], __read(args), false));
        },
        info: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return console.log.apply(console, __spreadArray([], __read(args), false));
        },
        warn: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return console.warn.apply(console, __spreadArray([], __read(args), false));
        },
        error: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return console.error.apply(console, __spreadArray([], __read(args), false));
        },
    };
}
export var defaultLogger = new Logger();
//# sourceMappingURL=logger.js.map